<script setup>
    import { isEmpty } from '@/libs/utils';

    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
    const getData = (array)=>{
        let data = [];
        for(let i=0; i< 5; i++){
            data.push(array[i] == undefined ? {list:[]} : array[i]);
        }
        
        return data;
    }

</script>

<template>
    <div class="footer">
        <div class="wrapper">
            <div class="list-wrap">
                <div class="list"  v-if="props.data.data != undefined && !isEmpty(props.data.data)" v-for="(value,index) in getData(props.data.data)" :key="index">
                    
                    <div class="title" v-if="value.list[0] != undefined">{{ value.list[0].title || "" }}</div>
                    <div class="list-box">
                        <span v-for="(val,idx) in value.list.slice(1,15)">
                            <a :href="val.url" v-if="val.type == 2" target="_blank">{{ val.title }}</a>
                            <a-link :to="val.link.path" v-else>{{ val.title }}</a-link>
                        </span>
                    </div>
                </div>
            </div>
            <div class="link-wrap" v-if="props.data.data[5] != undefined && !isEmpty(props.data.data[5])">                                    
                <ul>
                    <li v-for="(value,index) in props.data.data[5].list">
                        <a :href="value.url" v-if="value.type == 2" target="_blank">{{ value.title }}</a>
                        <a-link :to="value.link.path" v-else>{{ value.title }}</a-link>
                    </li>
                </ul>
            </div>
            <div class="copyright" v-if="props.data.data[6] != undefined && !isEmpty(props.data.data[6])">
                <div v-html="props.data.data[6].content"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.footer {
    border-top: 1px solid #d9d9d9;
    .wrapper {
        width: 1200px;
        min-height: 150px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        .list-wrap {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            .list {
                display: flex;
                flex-direction: column;
                margin-right: 130px;
                &:last-child {
                    margin-right: 0;
                }
                .title {
                    width: 150px;
                    margin-top: 50px;
                    font-size: 16px;
                    color: #000;
                    margin-bottom: 30px;
                }
                .list-box {
                    display: flex;
                    flex-direction: column;
                    span {
                        color: #666;
                        font-size: 14px;
                        margin-bottom: 24px;
                        a {
                            color: #666;
                            text-decoration: none;
                            font-size: 14px;
                            &:hover {
                                color: #dc143c;
                            }
                        }
                    }
                }
            }
        }
        .link-wrap {
            height: 66px;
            border-top: 1px solid #d9d9d9;
            border-bottom: 1px solid #d9d9d9;
            ul {
                li {
                    display: inline-flex;
                    height: 66px;
                    line-height: 66px;
                    margin-right: 25px;
                    font-size: 14px;
                    color: #666;
                    a {
                        color: #666;
                        text-decoration: none;
                        font-size: 14px;
                        &:hover {
                            color: #dc143c;
                        }
                    }
                }
            }
        }
        .copyright {
            min-height: 50px;
        }
    }
}
</style>